import { useEffect, useState } from 'react';

import { fetchScreeningQuestions } from '@/services/screeningQuestions';

import type { ScreeningSetOutcome } from '../types';

/** `undefined` while the read is in flight; the outcome once it settles. */
export type ScreeningSetState = ScreeningSetOutcome | undefined;

/**
 * Reads the screening set once, when the fit questions screen mounts [03-us-kpw-3a AC-11].
 *
 * Local state, not the session store: the set is server state and only this screen reads it (convention
 * skill § 6). Once per mount, never a poll — the questions a candidate is answering must not change under
 * their finger. Same shape and the same unmount guard as `useOpenings`.
 */
export function useScreeningQuestions(): ScreeningSetState {
  const [outcome, setOutcome] = useState<ScreeningSetState>(undefined);

  useEffect(() => {
    let live = true;
    void fetchScreeningQuestions().then((result) => {
      // A candidate who walks away mid-read ends the session and unmounts this; the answer goes nowhere.
      if (live) setOutcome(result);
    });
    return () => {
      live = false;
    };
  }, []);

  return outcome;
}
